import React from "react";
import { BaseRateTaxedAmount } from "../../../model/accounting/vat/BaseRateTaxedAmount.js";
import { FieldHeading } from "./FieldHeading.js";
import { FieldSubHeading } from "./FieldSubHeading.js";
import { FieldSubItem } from "./FieldSubItem.js";

type Props = {
  vatBaseTaxedAmount: BaseRateTaxedAmount;
};

/**
 * Generates table rows for the VAT report field 1.
 */
export const VatReportField1 = ({ vatBaseTaxedAmount }: Props) => {
  const { salesItems, reverseChargedItems, total, sales, reverseCharged } = vatBaseTaxedAmount;

  return (
    <>
      <FieldHeading
        label="Väli 1"
        description="24% määraga maksustatavad toimingud ja tehingud."
        total={total}
        itemsCount={2 + salesItems.length + reverseChargedItems.length}
      />
      <FieldSubHeading label="Eesti müük" total={sales} itemsCount={salesItems.length} />
      {salesItems.map((queryItem) => (
        <FieldSubItem key={queryItem.id} queryItem={queryItem} />
      ))}
      <FieldSubHeading
        label="Pöörd-KM tekitav käive"
        total={reverseCharged}
        itemsCount={reverseChargedItems.length}
      />
      {reverseChargedItems.map((queryItem) => (
        <FieldSubItem key={queryItem.id} queryItem={queryItem} />
      ))}
    </>
  );
};
